// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React, { useEffect, useState } from 'react';
import { NewsApis } from '../../../services/listNews';
import useMessage from '../toast/UseMessage';
import './styles.scss';
import { useAppSelector } from '../../../store';
import { listsErrorNotShowToast } from '../../../constants';
import JSCookie from 'js-cookie';
import { useLocation } from 'react-router-dom';

function NotifyNews(props) {
  const {
    auth: { isShowNews },
  } = useAppSelector((state) => state);
  const authToken = JSCookie.get('token');
  const { openMessageError } = useMessage();
  const [count, setCount] = useState(0);
  const location = useLocation();
  const getNewsNotSeen = async () => {
    try {
      const res = await NewsApis.getNewsNotSeen();
      const { data } = res;
      setCount(data?.count);
    } catch (error) {
      if (!listsErrorNotShowToast.includes(Number(error?.response?.status))) {
        openMessageError(error);
      }
    }
  };
  useEffect(() => {
    if (authToken) {
      getNewsNotSeen();
    }
  }, [location]);

  return (
    <>
      {count > 0 && isShowNews && (
        <>
          <div className="new-number-PC"></div>
          <div className="new-number-SP"></div>
        </>
      )}
    </>
  );
}

export default NotifyNews;
